/**
* @ngdoc component
* @name help.component:itxHelpBreadcrumb
* @requires help.service:helpService
* @description
* Breadcrumb component.
* Will show the texts and links based in the current state.
* Get the information from {@link help.service:helpService#getBreadcrumb getBreadcrumb} method, so there is no need to pass it params.
* Possible states:
* - submenu: Only shows submenu title text
* - content: Show submenu title text and link, and content text.
*/
(function() {
    'use strict';

    var itxHelpBreadcrumb = {
        controllerAs: '$ctrl',
        controller:   itxHelpBreadcrumbCtrl,
        templateUrl: 'help-breadcrumb.component.html'
    };

    itxHelpBreadcrumbCtrl.$inject = [
        '$state',
        'helpService'
    ];

    function itxHelpBreadcrumbCtrl (
        $state,
        helpService
    ) {
        var _this = this;

        _this.$onInit = function () {
            

            _this.breadcrumb = helpService.getBreadcrumb();

            _this.isSubmenu = ($state.current.name=='submenu');

            _this.isContent= ($state.current.name=='content');
        };

        _this.back=function(){
            history.back();
        };
    }

    angular.module('itxApp.help')
    .component('itxHelpBreadcrumb',itxHelpBreadcrumb);

})();